import { BASE } from "@constants/common-data";

/**
 * 조직 데이터
 */
export const CompanyData = {
  workField: {
    label: "",
    text: "",
    items: [
      {
        text: "유통/시공사",
        value: 0,
      },
      {
        text: "제조/도매상",
        value: 1,
      },
      {
        text: "플랫폼",
        value: 2,
      },
    ],
  },

  approvalStatus: {
    label: "",
    text: "",
    items: [
      {
        text: "신청 완료",
        value: 0,
      },
      {
        text: "검토중",
        value: 1,
      },
      {
        text: "승인 완료",
        value: 2,
      },
      {
        text: "승인 거절",
        value: 3,
      },
      {
        text: "사용 중단",
        value: 4,
      },
      {
        text: "임의 가입",
        value: 5,
      },
      {
        text: "폐업/휴업",
        value: 6,
      },
    ],
  },

  businessDiv: {
    label: "",
    text: "",
    items: [
      {
        text: "개인사업자",
        value: 0,
      },
      {
        text: "법인사업자",
        value: 1,
      },
    ],
  },

  workBuildingFields: {
    label: "",
    text: "",
    items: [
      {
        text: "단동온실",
        value: 0,
      },
      {
        text: "연동온실",
        value: 1,
      },
      {
        text: "유리온실",
        value: 2,
      },
      {
        text: "식물공장",
        value: 3,
      },
    ],
  },

  workEquipmentFields: {
    label: "",
    text: "",
    items: [
      {
        text: "환기설비",
        value: 0,
      },
      {
        text: "관수설비",
        value: 1,
      },
      {
        text: "양액설비",
        value: 2,
      },
      {
        text: "난방설비",
        value: 3,
      },
      {
        text: "냉방설비",
        value: 4,
      },
      {
        text: "복합환경제어설비",
        value: 5,
      },
      {
        text: "아쿠아포닉스설비",
        value: 6,
      },
      {
        text: "축사자동화설비",
        value: 7,
      },
      {
        text: "양식자동화설비",
        value: 8,
      },
    ],
  },

  workGreenhouseMaterialFields: {
    label: "",
    text: "",
    items: [
      {
        text: "골조류",
        value: 0,
      },
      {
        text: "피복류",
        value: 1,
      },
      {
        text: "개폐류",
        value: 2,
      },
      {
        text: "환기류",
        value: 3,
      },
      {
        text: "관수류",
        value: 4,
      },
      {
        text: "양액설비류",
        value: 5,
      },
      {
        text: "냉난방류",
        value: 6,
      },
      {
        text: "복합환경제어설비",
        value: 7,
      },
      {
        text: "생육장치류",
        value: 8,
      },
    ],
  },

  workPlantingMaterialFields: {
    label: "",
    text: "",
    items: [
      {
        text: "농약",
        value: 0,
      },
      {
        text: "비료/영양제",
        value: 1,
      },
      {
        text: "씨앗/모종",
        value: 2,
      },
      {
        text: "사료",
        value: 3,
      },
    ],
  },

  workHardwareToolsFields: {
    label: "",
    text: "",
    items: [
      {
        text: "배관자재",
        value: 0,
      },
      {
        text: "소농기구",
        value: 1,
      },
      {
        text: "일반철물",
        value: 2,
      },
      {
        text: "조경자재",
        value: 3,
      },
    ],
  },

  workFarmingMachineFields: {
    label: "",
    text: "",
    items: [
      {
        text: "소형 농기계",
        value: 0,
      },
      {
        text: "대형 농기계",
        value: 1,
      },
    ],
  },

  annualSalesSize: {
    label: "",
    text: "",
    items: [
      {
        text: "신생",
        value: 0,
      },
      {
        text: "연10억이하",
        value: 1,
      },
      {
        text: "연30억이하",
        value: 2,
      },
      {
        text: "연50억이하",
        value: 3,
      },
      {
        text: "연50억이상",
        value: 4,
      },
    ],
  },

  licenses: {
    label: "",
    text: "",
    items: [
      {
        text: "온실면허",
        value: 0,
      },
      {
        text: "건축설계자격",
        value: 1,
      },
      {
        text: "농약판매관리",
        value: 2,
      },
    ],
  },

  docOffers: {
    label: "",
    text: "",
    items: [
      {
        text: "표준계약서",
        value: 0,
      },
      {
        text: "표준견적서",
        value: 1,
      },
      {
        text: "원가계산서",
        value: 2,
      },
      {
        text: "설계도",
        value: 3,
      },
      {
        text: "시방서",
        value: 4,
      },
      {
        text: "공정표",
        value: 5,
      },
      {
        text: "세금계산서",
        value: 6,
      },
      {
        text: "현금영수증",
        value: 7,
      },
      {
        text: "전문감리",
        value: 8,
      },
      {
        text: "하자이행증권",
        value: 9,
      },
      {
        text: "계약이행증권",
        value: 10,
      },
    ],
  },

  addServices: {
    label: "",
    text: "",
    items: [
      {
        text: "정부보조사업",
        value: 0,
      },
      {
        text: "정부융자사업",
        value: 1,
      },
      {
        text: "현장견학",
        value: 2,
      },
      {
        text: "직영시공",
        value: 3,
      },
      {
        text: "마감청소",
        value: 4,
      },
      {
        text: "재배컨설팅",
        value: 5,
      },
      {
        text: "생육컨설팅",
        value: 6,
      },
      {
        text: "직영농장",
        value: 7,
      },
      {
        text: "생산물수매/유통",
        value: 8,
      },
      {
        text: "직영매장",
        value: 9,
      },
    ],
  },

  exportExperience: {
    label: "",
    text: "",
    items: [
      {
        text: "수출 경험 있음",
        value: true,
      },
      {
        text: "수출 경험 없음",
        value: false,
      },
    ],
  },

  joinedRoute: {
    label: "",
    text: "",
    items: [
      {
        text: "우편",
        value: 0,
      },
      {
        text: "문자",
        value: 1,
      },
      {
        text: "기사",
        value: 2,
      },
      {
        text: "블로그",
        value: 3,
      },
      {
        text: "유튜브",
        value: 4,
      },
      {
        text: "SNS",
        value: 5,
      },
      {
        text: "지인소개",
        value: 6,
      },
      {
        text: "직접검색",
        value: 7,
      },
      {
        text: "기타",
        value: 8,
      },
    ],
  },

  publicables: {
    label: "",
    text: "",
    items: [
      {
        text: "시공사 찾기",
        value: 1,
      },
      {
        text: "농약사 찾기",
        value: 2,
      },
    ],
  },

  serviceTypes: {
    label: "",
    text: "",
    items: [
      {
        text: "시공사",
        value: 10,
      },
      {
        text: "농약사",
        value: 11,
      },
      {
        text: "농자재상",
        value: 12,
      },
      {
        text: "제조사",
        value: 13,
      },
      {
        text: "관공서",
        value: 14,
      },
      {
        text: "기타",
        value: 98,
      },
      {
        text: "운영자",
        value: 99,
      },
    ],
  },

  shortCutRoute: [
    {
      text: "전문설계 등록",
      value: "company-design-create",
    },
    {
      text: "전문설계 목록",
      value: "company-design-list",
    },
    {
      text: "전문설계 설정",
      value: "company-design-preference",
    },
    {
      text: "전문설계 휴지통",
      value: "company-design-list-deleted",
    },
    {
      text: "템플릿 등록",
      value: "company-design-template-create",
    },
    {
      text: "템플릿 수정",
      value: "company-design-template-update",
    },
    {
      text: "템플릿 휴지통",
      value: "company-design-template-list-deleted",
    },
    {
      text: "상품 목록",
      value: "company-item-product-list",
    },
    {
      text: "고객 등록",
      value: "company-customer-create",
    },
    {
      text: "고객 목록",
      value: "company-customer-list",
    },
    {
      text: "조직 요금제",
      value: "company-company-charge",
    },
    {
      text: "조직원 등록",
      value: "company-employee-create",
    },
    {
      text: "조직원 목록",
      value: "company-employee-list",
    },
  ],

  imageCategory: {
    label: "",
    desc: "",
    items: [
      {
        text: "대표 이미지(메인)",
        value: 1,
      },
      {
        text: "외부 전경",
        value: 2,
      },
      {
        text: "내부 전경",
        value: 3,
      },
      {
        text: "시공 사례",
        value: 4,
      },
      {
        text: "분류 없음(기타)",
        value: 0,
      },
    ],
  },

  badgeCategory: {
    label: "",
    desc: "",
    items: [
      {
        text: "작물",
        value: 1,
      },
      {
        text: "대리점",
        value: 2,
      },
      {
        text: "구분 없음",
        value: 0,
      },
    ],
  },

  kakaoAllim: {
    label: "",
    desc: "",
    items: [
      {
        text: "알림 받음",
        value: true,
      },
      {
        text: "알림 받지 않음",
        value: false,
      },
    ],
  },
  shippable: {
    label: "",
    desc: "",
    items: [
      {
        text: "배달 가능",
        value: true,
      },
      {
        text: "배달 불가능",
        value: false,
      },
    ],
  },
  certified: {
    label: "",
    desc: "",
    items: [
      {
        text: "인증",
        value: true,
      },
      {
        text: "미인증",
        value: false,
      },
    ],
  },

  chargeRateSystem: {
    label: "",
    text: "",
    items: [
      {
        text: "베이직",
        value: 0,
      },
      {
        text: "스탠다드",
        value: 1,
      },
      {
        text: "프리미엄",
        value: 2,
      },
      {
        text: "엔터프라이즈",
        value: 3,
      },
      {
        text: "소유주",
        value: 4,
      },
    ],
  },

  chargeExpired: {
    label: "",
    text: "",
    items: [
      {
        text: "미사용",
        value: true,
      },
      {
        text: "사용중",
        value: false,
      },
    ],
  },

  isBrokerage: {
    label: "",
    text: "",
    items: [
      {
        text: "중개 받음",
        value: true,
      },
      {
        text: "중개 받지 않음",
        value: false,
      },
    ],
  },
};

export const HandlingItemData: any = [
  {
    value: "재배자재",
    items: [
      {
        category: "재배자재",
        name: "농약",
      },
      {
        category: "재배자재",
        name: "비료/상토",
      },
      {
        category: "재배자재",
        name: "친환경제품",
      },
    ],
  },
  {
    value: "종묘",
    items: [
      {
        category: "종묘",
        name: "종자/모종",
      },
      {
        category: "종묘",
        name: "육묘",
      },
      {
        category: "종묘",
        name: "화훼/묘목",
      },
    ],
  },
  {
    value: "시설자재",
    items: [
      {
        category: "시설자재",
        name: "하우스 시설자재",
      },
      {
        category: "시설자재",
        name: "관수자재",
      },
      {
        category: "시설자재",
        name: "비닐/부직포",
      },
      {
        category: "시설자재",
        name: "차광막/기타망",
      },
    ],
  },
  {
    value: "농업자재",
    items: [
      {
        category: "농업자재",
        name: "원예/과수자재",
      },
      {
        category: "농업자재",
        name: "철물/공구",
      },
      {
        category: "농업자재",
        name: "소농기구",
      },
    ],
  },
];

export const COMPANYIMAGE: CompanyImage = {
  id: null,
  companyId: null,
  imageUrl: null,
  order: null,
  category: null,
  deleted: null,
};
export const BADGE: CompanyBadge = {
  id: null,
  imageUrl: null,
  category: null,
  title: null,
  description: null,
};

export const BADGES: Badges = {
  id: null,
  badge: BADGE,
  badgeOrder: null,
};

export const COMPANY: Company = {
  ...BASE,
  preference: null,
  agreeAge: false,
  agreeTerms: false,
  agreePrivacy: false,
  agreeLegal: false,
  charge: null,
  expertId: null,
  companyName: null,
  regName: null,
  ceoName: null,
  regNumber: null,
  businessDiv: 0,
  businessType: null,
  businessTypeDetail: null,
  address: {
    postcode: null,
    road: null,
    jibeon: null,
    detail: null,
  },
  phoneNumber: null,
  phoneNumber2: null,
  faxNumber: null,
  email: null,
  taxEmail: null,
  homepageUrl: null,
  blogUrl: null,
  profileImageSrc: null,
  regNumberFileUrl: null,
  residentCardImageSrc: null,

  workField: null,
  workBuildingFields: [],
  workEquipmentFields: [],
  workGreenhouseMaterialFields: [],
  workPlantingMaterialFields: [],
  workHardwareToolsFields: [],
  workFarmingMachineFields: [],
  annualSalesSize: 0,
  workBuilding2Fields: [],
  workDistributingFields: [],
  workManufacturingFields: [],
  workInstitutionFields: [],
  workPeriod: null,
  asPeriod: null,
  minBuildingCost: null,
  licenses: [],
  docOffers: [],
  addServices: [],
  serviceAreas: null,
  wholeCountry: null,
  exportExperience: null,
  exportAreas: null,
  intro: null,

  pageOpened: true,
  expertAuth: false,
  joinedRoute: null,
  agressTermsFourteen: false,
  agreeTermsService: false,
  agreePrivacyPolicy: false,
  agreeMarketing: false,

  maxEmployee: 10,
  registeredEmployee: null,
  note: null,
  approvalStatus: null,
  createDate: null,
  lastUpdate: null,
  district_1: null,
  district_2: null,
  district_3: null,
  latitude: 0,
  longitude: 0,
  publicables: [],
  bizcallNumber: null,
  kakaoAllim: false,
  mobileNumber: null,
  hcostKakaoAlarmLocations: null,
  shippable: false,
  handlingItems: [],
};

// 인증 뱃지 여부 필드 추가, kakaoAllim, mobileNumber 변수명 수정
export const COMPANYV2: CompanyV2 = {
  ...BASE,
  preference: null,
  agreeAge: null,
  agreeTerms: null,
  agreePrivacy: null,
  agreeLegal: null,
  charge: null,
  expertId: null,
  companyName: null,
  regName: null,
  ceoName: null,
  regNumber: null,
  businessDiv: null,
  businessType: null,
  businessTypeDetail: null,
  address: {
    postcode: null,
    road: null,
    jibeon: null,
    detail: null,
  },
  phoneNumber: null,
  phoneNumber2: null,
  faxNumber: null,
  email: null,
  taxEmail: null,
  homepageUrl: null,
  blogUrl: null,
  profileImageSrc: null,
  regNumberFileUrl: null,
  residentCardImageSrc: null,

  workField: null,
  workBuildingFields: [],
  workEquipmentFields: [],
  workGreenhouseMaterialFields: [],
  workPlantingMaterialFields: [],
  workHardwareToolsFields: [],
  workFarmingMachineFields: [],
  annualSalesSize: null,
  workBuilding2Fields: [],
  workDistributingFields: [],
  workManufacturingFields: [],
  workInstitutionFields: [],
  workPeriod: null,
  asPeriod: null,
  minBuildingCost: null,
  licenses: [],
  docOffers: [],
  addServices: [],
  serviceAreas: null,
  wholeCountry: null,
  exportExperience: null,
  exportAreas: null,
  intro: null,

  pageOpened: true,
  expertAuth: null,
  joinedRoute: null,
  agressTermsFourteen: null,
  agreeTermsService: null,
  agreePrivacyPolicy: null,
  agreeMarketing: null,

  maxEmployee: 10,
  registeredEmployee: null,
  note: null,
  approvalStatus: null,
  createDate: null,
  lastUpdate: null,
  district_1: null,
  district_2: null,
  district_3: null,
  latitude: null,
  longitude: null,
  publicables: [],
  bizcallNumber: null,
  kakaoAlarm: null,
  kakaoIncomingNumber: null,
  hcostKakaoAlarmLocations: null,
  shippable: null,
  handlingItems: [],
  certified: null,
};

// v0.0.10
export const companyBrokeragePreference: BrokeragePreferenceRequest = {
  counselor: null,
  districts: null,
  facilities: null,
  enabled: null,
  minAreaPyeong: null,
  maxAreaPyeong: null,
};
export const COMPANYV3: CompanyV3 = {
  ...BASE,
  preference: null,
  agreeAge: null,
  agreeTerms: null,
  agreePrivacy: null,
  agreeLegal: null,
  charge: null,
  expertId: null,
  companyName: null,
  regName: null,
  ceoName: null,
  regNumber: null,
  businessDiv: null,
  businessType: null,
  businessTypeDetail: null,
  address: {
    postcode: null,
    road: null,
    jibeon: null,
    detail: null,
  },
  phoneNumber: null,
  phoneNumber2: null,
  faxNumber: null,
  email: null,
  taxEmail: null,
  homepageUrl: null,
  blogUrl: null,
  profileImageSrc: null,
  regNumberFileUrl: null,
  residentCardImageSrc: null,

  workBuildingFields: [],
  workEquipmentFields: [],
  annualSalesSize: null,
  workBuilding2Fields: [],
  workDistributingFields: [],
  workManufacturingFields: [],
  workInstitutionFields: [],
  workPeriod: null,
  asPeriod: null,
  minBuildingCost: null,
  licenses: [],
  addServices: [],
  serviceAreas: null,
  wholeCountry: null,
  exportExperience: null,
  exportAreas: null,
  intro: null,

  pageOpened: true,
  expertAuth: null,
  joinedRoute: null,
  agressTermsFourteen: null,
  agreeTermsService: null,
  agreePrivacyPolicy: null,
  agreeMarketing: null,

  maxEmployee: 10,
  registeredEmployee: null,
  note: null,
  approvalStatus: null,
  createDate: null,
  lastUpdate: null,
  district_1: null,
  district_2: null,
  district_3: null,
  latitude: null,
  longitude: null,
  publicables: [],
  bizcallNumber: null,
  kakaoAlarm: null,
  kakaoIncomingNumber: null,
  hcostKakaoAlarmLocations: null,
  shippable: null,
  handlingItems: [],
  certified: null,
  serviceTypes: [],
  defaultEmployee: null,

  brokeragePreference: companyBrokeragePreference,
};
